import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../hooks/useTheme';

/** Light/dark switch: the icons rotate and the new theme spreads out in a circle from the button. */
export function ThemeToggle({ className = '', size = 'btn-sm' }: { className?: string; size?: string }) {
  const { dark, toggle } = useTheme();
  const label = dark ? 'Switch to light theme' : 'Switch to dark theme';
  return (
    <button
      type="button"
      className={`btn swap swap-rotate btn-square btn-ghost ${size} ${dark ? 'swap-active' : ''} ${className}`}
      onClick={(e) => {
        const r = e.currentTarget.getBoundingClientRect();
        toggle({ x: r.left + r.width / 2, y: r.top + r.height / 2 });
      }}
      aria-label={label}
      title={label}
    >
      <Sun className="swap-off size-[1.125rem]" aria-hidden="true" />
      <Moon className="swap-on size-[1.125rem]" aria-hidden="true" />
    </button>
  );
}
